
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsApp = ({ phoneNumber }) => {
  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`,"_blank");
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#25D366",
        color: "#fff",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
        zIndex: 1000,
      }}
      onClick={handleClick}
    >
      <FaWhatsapp size={30} />
    </div>
  );
};

export default WhatsApp;

